import {
  Box,
  Table,
  Text,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  BoxProps,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { IFeatureBase } from '../../../../../../../../../../../models/features';
import { showFeatureGroupsService } from '../../../../../../../../../../../services/FeatureGroups/ShowFeatureGroupsService';
import { translateError } from '../../../../../../../../../../../utils/errors';

interface IUserFeaturesTableProps extends BoxProps {
  featureGroupId: string;
}

export const UserFeaturesTable = ({
  featureGroupId,
  ...rest
}: IUserFeaturesTableProps): JSX.Element => {
  const toast = useToast();

  const [featuresList, setFeatureslist] = useState<IFeatureBase[]>([]);

  useEffect(() => {
    async function loadFeatures(groupId: string): Promise<void> {
      try {
        const featureGroup = await showFeatureGroupsService(groupId);

        if (featureGroup) {
          setFeatureslist(featureGroup.features);
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status !== 401) {
          toast({
            title: 'Falha ao carregar dados',
            description:
              translateError({ message: err.response?.data.message }) ||
              'Ocorreu um erro ao carregar as permissões, tente novamente.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            variant: 'subtle',
            position: 'top-right',
          });
        }
      }
    }

    loadFeatures(featureGroupId);
  }, [featureGroupId, toast]);

  return (
    <Box {...rest}>
      <Table colorScheme="blue" mt="4">
        <Thead>
          <Tr>
            <Th>Nome</Th>
          </Tr>
        </Thead>

        <Tbody>
          {featuresList.map((feature) => (
            <Tr key={feature.id}>
              <Td>
                <Text fontWeight="bold">{feature.name}</Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
